<div class="bg-[#0F2167] border-t text-white p-1 text-center  fixed bottom-0 w-full text-sm">
  {{ "developed_by_ega" | translate }}
</div>
